
import { types, actions } from './requests'
export const SETARTICLEVARIANTORDERING_TYPES = {
    ...types('SETARTICLEVARIANTORDERING'),
}
export const SETARTICLEVARIANTORDERING_ACTIONS = {
    ...actions('SETARTICLEVARIANTORDERING'),
}